import axios from 'axios';
import { store } from '../store';

export function loadLeadStatusOptions() {
  const { token } = store.getState().auth;

  return axios({
    method: 'get',
    url: `${process.env.REACT_APP_MMB_API_URL}/api/supervisor/leadstatus/`,
    headers: { Authorization: `Token ${token}` },
  }).then(({ data = {} }) => (data))
    .catch(err => {
      console.error(err);
    });
}
